import actions from './actions'
import mutations, { state } from './mutations'
import getters from './getters'

export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}
